import { UntypedFormControl, AbstractControl } from '@angular/forms';
import { VALIDATION_ERROR as VE } from '@models-global/validation-errors';

export function getValidationMessage(
  formControl: UntypedFormControl | AbstractControl
): string {
  const keys = Object.keys(formControl?.errors ?? []);
  if (Array.isArray(keys) && keys.length > 0) {
    if (keys[0] === VE.REQUIRED) {
      return 'required';
    }
    if (keys[0] === VE.EMAIL || keys[0] === VE.WEBSITE) {
      return 'has incorrect format';
    }
    if (keys[0] === VE.MIN_LENGTH) {
      return ' too short';
    }
    if (keys[0] === VE.MIN_VALUE || keys[0] === VE.MIN_VALUE2) {
      return 'below minimum';
    }
    if (keys[0] === VE.MAX_LENGTH) {
      return ' too long';
    }
    if (keys[0] === VE.MAX_VALUE || keys[0] === VE.MAX_VALUE2) {
      return 'exceeds maximum';
    }
    if (keys[0] === VE.PHONE || keys[0] === VE.PATTERN) {
      return 'has incorrect format';
    }
    if (keys[0] === VE.PUBLIC_DOMAIN) {
      return 'should not have public domain';
    }
    if (
      keys[0] === VE.ONLY_LETTERS ||
      keys[0] === VE.ONLY_LETTERS_WITH_SPACES
    ) {
      return 'should have only letters';
    }
    if (keys[0] === VE.ONLY_LETTERS_AND_NUMBERS) {
      return 'should have only letters and numbers';
    }
    if (keys[0] === VE.DATE_LESS_THEN) {
      return 'date less then';
    }
    if (keys[0] === VE.DATE_MORE_THEN) {
      return 'date more then';
    }
    if (keys[0] === VE.DATE_RANGE_OVERLAP) {
      return 'Date range overlaps with another';
    }
    if (keys[0] === VE.ONLY_NUMBERS) {
      return 'should contain only numbers';
    }
    if (keys[0] === VE.ONE_REQUIRED) {
      return 'At least one of checkboxes must be checked';
    }
    if (keys[0] === VE.UNIQUE_NAME) {
      return 'This name has already been taken';
    }
    if (keys[0] === VE.UNIQUE_EMAIL) {
      return 'This email is already in use';
    }
    if (keys[0] === VE.UNIQUE_LABELER_ID) {
      return 'Labeler ID already taken';
    }
    if (keys[0] === VE.UNIQUE_YEAR) {
      return 'This year is already being used';
    }
    if (keys[0] === VE.NOT_FOUND) {
      return 'Entity not found';
    }
    if (keys[0] === VE.NO_MESSAGE) {
      return '';
    }
    return 'unknownError';
  }
  return '';
}
